import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericTileBodyModule } from '../../components/generic-tile-body/generic-tile-body.component';
import { SharedModule } from '../../shared/shared.module';
import { GenericTileComponent } from './generic-tile.component';
import { TileProgressLabelComponent } from './tile-progress-label/tile-progress-label.component';

@NgModule({
  imports: [CommonModule, GenericTileBodyModule, SharedModule],
  declarations: [GenericTileComponent, TileProgressLabelComponent],
  exports: [GenericTileComponent, TileProgressLabelComponent],
  providers: [],
})
export class GenericTileModule {}



// WEBPACK FOOTER //
// ./ts/app/home/generic-tile/generic-tile.module.ts